// Environment settings (API, Cognito, CDN) — read at startup, not baked into
// the build, so the exact build tested on dev.app.cinesplat.com is the one
// promoted to app.cinesplat.com.
//
// public/env-config.js sets window.__CINESPLAT_CONFIG__ and is loaded by
// index.html before the app. The committed copy is empty; each deploy
// writes the environment's own values from its Terraform outputs
// (infra/stack/env-config.sh <env>) and serves it uncached.
//
// A production build without them refuses to start (with a visible
// message) — there are no built-in fallbacks to any environment. Only
// `npm start` (development) falls back to the REACT_APP_* values from
// frontend/.env.development.local (npm start only).
const KEYS = ['apiUrl', 'capturesCdnUrl', 'uploadsBaseUrl', 'cognitoUserPoolId', 'cognitoAppClientId', 'cognitoRegion'];

const fromWindow = (typeof window !== 'undefined' && window.__CINESPLAT_CONFIG__) || {};
// `npm start` only. Written as direct process.env references inside a
// NODE_ENV check so a production build drops this whole branch — no
// environment's values end up inside the shared build.
const devFallback = process.env.NODE_ENV === 'development' ? {
  apiUrl: process.env.REACT_APP_API_URL,
  capturesCdnUrl: process.env.REACT_APP_CAPTURES_CDN_URL,
  uploadsBaseUrl: process.env.REACT_APP_S3_UPLOADS_BASE_URL,
  cognitoUserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  cognitoAppClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
  cognitoRegion: process.env.REACT_APP_COGNITO_REGION,
} : {};

const config = {};
const missing = [];
KEYS.forEach((key) => {
  const value = fromWindow[key] || devFallback[key];
  if (value) config[key] = value;
  else missing.push(key);
});
if (fromWindow.environment) config.environment = fromWindow.environment;

if (missing.length) {
  const message = `CineSplat configuration missing (${missing.join(', ')}) — env-config.js was not deployed for this environment.`;
  if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', () => {
      document.body.innerHTML = `<p style="font-family:Inter,Arial,sans-serif;color:#fff;background:#20252b;margin:0;padding:40px;min-height:100vh">${message}</p>`;
    });
  }
  throw new Error(message);
}

export default Object.freeze(config);
